import api from "./api";

let cache = null;

export async function getSiteMeta() {
  if (cache) return cache;
  try {
    const r = await api.get("/meta");
    cache = r.data;
  } catch (e) {
    cache = { issue: 1 };
  }
  return cache;
}
